// Shared badge/label maps for ticket status, priority, and SLA state — used by both
// the inbox list and the ticket-detail view (extracted to a single source of truth per
// the repo's "refactor at the 2nd duplicate" rule).

export const SLA_LABELS: Record<string, string> = {
  on_track: 'On track', at_risk: 'At risk', breached: 'Breached',
};
const STATUS_BADGE: Record<string, string> = {
  new: 'bt-badge--info', active: 'bt-badge--brand', pending: 'bt-badge--warning',
  resolved: 'bt-badge--success', closed: 'bt-badge--neutral',
};
const PRIORITY_BADGE: Record<string, string> = {
  critical: 'bt-badge--danger', high: 'bt-badge--warning', low: 'bt-badge--neutral',
  feature_request: 'bt-badge--info',
};
const SLA_BADGE: Record<string, string> = {
  on_track: 'bt-badge--success', at_risk: 'bt-badge--warning', breached: 'bt-badge--danger',
};

export function slaLabel(state: string): string { return SLA_LABELS[state] ?? state; }
export function priorityLabel(priority: string): string { return priority === 'feature_request' ? 'Feature' : priority; }
export function statusBadgeClass(status: string): string { return STATUS_BADGE[status] ?? 'bt-badge--neutral'; }
export function priorityBadgeClass(priority: string): string { return PRIORITY_BADGE[priority] ?? 'bt-badge--neutral'; }
export function slaBadgeClass(state: string): string { return SLA_BADGE[state] ?? 'bt-badge--neutral'; }
